module.exports = __webpack_public_path__ + "img/vps_pattern2.07070de.png";